function createSounds (overwrite = {}) {
  return {
    settings: {
      preload: true,
      volume: 1,
      ...overwrite.settings
    },
    players: {
      ...overwrite.players
    }
  };
}

export { createSounds };
